import React from 'react'
import lock from '../../Assets/images/circle-cta.jpg'
import Constant from '../../Constant'
import Button from '../SelectValue/Button'
import FadeInSection from '../FadeInSection'

function Own() {
    return (
        <FadeInSection>
            <div className='px-6 sm:px-24 grid pb-20 pt-20 sm:grid-cols-2 md:grid-cols-3 gap-5 bg-text-gray'>
                <div className='order-last sm:order-first'>
                    <img
                        src={lock}
                        className="mx-auto w-64 sm:w-80 md:w-96 h-auto object-contain"
                        alt="Unlock image"
                    />                 </div>
                <div className='sm:mb-0 mb-6 md:col-span-2'>
                    <h1 className='text-[24px] font-[400] mb-5 sm:text-[44px] text-text-color1'>
                        Don’t Just Save. <span className={Constant.linearColor}>Grow Together.</span>
                    </h1>
                    <p className='text-text-color1 font-normal text-[16px] sm:text-[18px] mb-5'>
                        Join your Circle today and experience barakah-driven wealth.
                    </p>
                    <Button name="Join a Circle Now" />
                </div>
            </div>
        </FadeInSection>
    )
}

export default Own
